export default __webpack_public_path__ + "static/media/drawing.prize.alert.4e42da2e.mp3";